import { mediaUrl } from '@/lib/mediaUrl';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, MessageCircle } from 'lucide-react';

const ACE_DEFAULT_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/c73989e2-94f9-4ce1-819f-4c865424ae2f/images/bc3ff2a2709fe073df48d0af22cbabbb8b55deeba4c1f27e83b0f363018789b5.jpeg';

const TIP_TYPE_META = {
  welcome:       { label: 'Welcome',           accent: '#02d1d4' },
  feedback_pass: { label: 'Well Done!',         accent: '#10B981' },
  feedback_fail: { label: 'Keep Going!',        accent: '#F59E0B' },
  summary:       { label: 'Key Takeaway',       accent: '#20acf6' },
  encouragement: { label: 'Encouragement',      accent: '#02d1d4' },
  custom:        { label: 'Trainer Tip',         accent: '#20acf6' },
};

const TrainerTipElement = ({ config, element, onComplete, isCompleted }) => {
  // Support both flat config (from seed) and nested config.trainer_tip (from builder)
  const nested = config.trainer_tip || {};
  const tipType = config.tip_type || nested.tip_type || 'custom';
  const text = config.text || nested.text || '';
  const aceImage = mediaUrl(config.ace_image_url || nested.ace_image_url) || ACE_DEFAULT_IMAGE;
  const aceAlt = config.ace_image_alt || nested.ace_image_alt || 'Ace - Learning Guide';
  const meta = TIP_TYPE_META[tipType] || TIP_TYPE_META.custom;

  return (
    <div className="space-y-4" data-testid="trainer-tip-element">
      <div className="relative rounded-2xl border-2 overflow-hidden" style={{ borderColor: `${meta.accent}40`, background: `linear-gradient(135deg, ${meta.accent}08, ${meta.accent}03)` }}>
        <div className="h-1" style={{ background: meta.accent }} />
        <div className="flex gap-4 p-5 sm:p-6">
          <div className="shrink-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden border-2 shadow-md" style={{ borderColor: `${meta.accent}50` }}>
              <img src={aceImage} alt={aceAlt} className="w-full h-full object-cover" data-testid="ace-avatar" />
            </div>
            <p className="text-center text-[10px] font-semibold mt-1.5" style={{ color: meta.accent }}>Ace</p>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold tracking-wide uppercase" style={{ backgroundColor: `${meta.accent}15`, color: meta.accent }} data-testid="trainer-tip-badge">
                <MessageCircle className="h-3 w-3" />{meta.label}
              </span>
            </div>
            <div className="relative bg-white rounded-xl p-4 shadow-sm border border-slate-100" data-testid="trainer-tip-bubble">
              <div className="absolute -left-2 top-4 w-3 h-3 bg-white border-l border-b border-slate-100 rotate-45" />
              {text ? (<div className="prose prose-sm prose-slate max-w-none text-sm leading-relaxed [&>p]:mb-2 [&>ul]:mb-2 [&>ol]:mb-2" dangerouslySetInnerHTML={{ __html: text }} />) : (<p className="text-sm text-slate-400 italic">No tip text configured.</p>)}
            </div>
          </div>
        </div>
      </div>
      {!isCompleted && <Button onClick={onComplete} className="bg-[#20acf6] hover:bg-[#3bb8f7]" data-testid="acknowledge-tip-btn"><Check className="h-4 w-4 mr-2" /> Got it, thanks Ace!</Button>}
    </div>
  );
};

export default TrainerTipElement;
